import React, { useState } from 'react';
import { Form, message } from 'antd';
import { natureNumFilterFunc } from 'utils/constant';
import { theme } from 'utils/style/theme';
import { bubbleSpriteApi } from 'apis/platform/bubbleSpriteApis';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import DropZoneImage from 'components/dropzoneUpload/DropZoneImage';
import DefaultModal from 'components/modal/DefaultModal';
import DefaultForm from 'components/form/DefaultForm';
import DefaultButton from 'components/button/DefaultButton';
import TextFlexBox from 'components/container/TextFlexBox';
import CheckboxOneType from 'components/input/CheckboxOneType';
import CurrentImgTag from 'components/etc/CurrentImgTag';
import { useTranslation } from 'react-i18next';
/**
 * * 플랫폼 관리 - 말풍선 이미지 수정
 */

const SpriteUpdateModal = (props) => {
  const { t } = useTranslation();
  const { record, fetchData, visible, setVisible, templateDropdownList } =
    props;
  const [file, setFile] = useState(null);
  const [form] = Form.useForm();
  const [detailData, setDetailData] = useState({
    image_name: record?.image_name,
    is_slice: record?.is_slice,
    border_left: record.border_left,
    border_right: record.border_right,
    border_bottom: record.border_bottom,
    border_top: record.border_top,
    bubble_sprite_id: record?.bubble_sprite_id,
    template: record?.template,
  });

  /// 모달창 닫기
  const handleClose = () => {
    setVisible(false);
    form.resetFields();
  };

  /// 인풋 이벤트
  const handleInputChange = (e) => {
    const { value, name, checked } = e.target;

    if (name === 'is_slice') {
      setDetailData({ ...detailData, is_slice: checked ? 1 : 0 });
    } else {
      setDetailData({ ...detailData, [name]: value });
    }
  };

  /// 드롭다운 이벤트
  const handleSelectChange = (e, data) => {
    const { name } = data;
    setDetailData({ ...detailData, [name]: e });
  };

  /// 이미지 태그 닫기
  const handleCloseCurrentImg = () => {
    setDetailData({ ...detailData, image_url: '' });
  };

  const handlePositionChange = (e) => {
    if (natureNumFilterFunc(e.target.value)) {
      return false;
    }
    let { value, name } = e.target;
    setDetailData({ ...detailData, [name]: value });
  };

  /// 데이터 전송
  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('bubble_sprite_id', record.bubble_sprite_id);
    formData.append('uploadFile', file);
    formData.append('image_name', detailData.image_name);
    formData.append('template', detailData.template);
    formData.append('is_slice', detailData.is_slice === true ? 1 : 0);
    formData.append('border_left', detailData.border_left);
    formData.append('border_right', detailData.border_right);
    formData.append('border_top', detailData.border_top);
    formData.append('border_bottom', detailData.border_bottom);

    await bubbleSpriteApi.update(formData);
    setVisible(false);
    fetchData();
    //   await postLogRequest('U', '말풍선 이미지 수정', userId);
    message.success('말풍선이 수정되었습니다.', 1);
  };
  return (
    <>
      <DefaultModal
        title={t('sprite.editSpeechBubbleImageModal.title')}
        visible={visible}
        onCancel={handleClose}
        footer={
          <DefaultButton onClick={handleSubmit}>
            {t('sprite.editSpeechBubbleImageModal.edit')}
          </DefaultButton>
        }
      >
        <DefaultForm form={form}>
          <div className='title_wrap'>
            <p>{t('sprite.editSpeechBubbleImageModal.speechBubbleImageID')}</p>
            <span>{record?.bubble_sprite_id}</span>
          </div>
          <TextFlexBox style={{ alignItems: 'flex-start' }}>
            <h6>{t('sprite.editSpeechBubbleImageModal.resizable')}</h6>
            <CheckboxOneType
              name='is_slice'
              checked={detailData?.is_slice === 1 ? true : false}
              onChange={handleInputChange}
            />
          </TextFlexBox>
          <DefaultInput
            title={t('sprite.editSpeechBubbleImageModal.name')}
            name='image_name'
            value={detailData?.image_name}
            onChange={handleInputChange}
            allowClear
            placeholder={t(
              'sprite.editSpeechBubbleImageModal.nameInputPlaceholder',
            )}
          />
          <DefaultSelect
            title={t('sprite.editSpeechBubbleImageModal.template')}
            name='template'
            value={detailData?.template}
            optionList={templateDropdownList}
            onChange={handleSelectChange}
          />

          <TextFlexBox>
            <DefaultInput
              title={t('sprite.editSpeechBubbleImageModal.leftBorder')}
              name='border_left'
              type='number'
              value={detailData?.border_left}
              onChange={handlePositionChange}
              style={{ marginRight: `${theme.margins.marginRight}` }}
            />

            <DefaultInput
              title={t('sprite.editSpeechBubbleImageModal.rightBorder')}
              name='border_right'
              type='number'
              value={detailData?.border_right}
              onChange={handlePositionChange}
            />
          </TextFlexBox>
          <TextFlexBox>
            <DefaultInput
              title={t('sprite.editSpeechBubbleImageModal.topBorder')}
              name='border_top'
              type='number'
              value={detailData?.border_top}
              onChange={handlePositionChange}
              style={{ marginRight: `${theme.margins.marginRight}` }}
            />
            <DefaultInput
              title={t('sprite.editSpeechBubbleImageModal.bottomBorder')}
              name='border_bottom'
              type='number'
              value={detailData?.border_bottom}
              onChange={handlePositionChange}
            />
          </TextFlexBox>

          <Form.Item name='uploadFile'>
            {detailData?.image_url === '' ? (
              <DropZoneImage setFile={setFile} />
            ) : (
              <CurrentImgTag
                src={record?.image_url}
                text={record?.image_name}
                onClose={handleCloseCurrentImg}
              />
            )}
          </Form.Item>
        </DefaultForm>
      </DefaultModal>
    </>
  );
};
export default SpriteUpdateModal;
